// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__Jjb_j","subheader":"ReorderModal_subheader__1GD4N","listWrap":"ReorderModal_listWrap__1WXyP"};